export default {
    data() {
        return {
            baseUrl: this.$global.baseUrl,
            userInfo: {},
            collapsed: false,
            currentRouteTitle: ""
        }
    },
    mounted: function () {
        this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        this.$router.afterEach((to, from) => {
            this.currentRouteTitle = to.meta.title;
        });
        //组件间通信 更新个人信息
        var _this = this;
        this.$event.$on("updateUserInfo", function () {
            var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            _this.userInfo = userInfo;
        });
    },
    methods: {
        clickEvent: function (id) {
            switch (id) {
                case "collapse": //点击折叠/展开
                    this.collapsed = !this.collapsed;
                    this.$event.$emit("changeCollapse", this.collapsed);
                    break;
                case "toMyInfo": //跳转到个人信息
                    this.$router.push("/my_info");
                    break;
                case "toUpdatePassword": //跳转到修改密码
                    this.$router.push("/update_password");
                    break;
                case "loginout"://切换账号
                    this.$confirm('此操作将注销当前账号, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        localStorage.removeItem("token");
                        sessionStorage.removeItem("isLogin");
                        sessionStorage.removeItem("userInfo");
                        this.$router.push("/login");
                        this.$message({
                            type: 'success',
                            message: '注销成功!'
                        });
                    }).catch(() => { });
                    break;
                default:
                    break;
            }
        }
    }
}